/**
 * Message 消息提示函数式调用
 * @author Nemo
 */
import Vue from 'vue';
import MessageComponent from './index.vue';

const MessageConstructor = Vue.extend(MessageComponent);

// 创建并显示消息
const showMessage = (options) => {
  const instance = new MessageConstructor({
    propsData: options,
  });
  
  const vm = instance.$mount();
  document.body.appendChild(vm.$el);
  
  return instance;
};

// OnMessage 主对象
const OnMessage = {
  success(message, duration = 3000) {
    return showMessage({
      type: 'success',
      message,
      duration,
    });
  },
  error(message, duration = 3000) {
    return showMessage({
      type: 'error',
      message,
      duration,
    });
  },
};

export default OnMessage;

